export function getString(value, defaultValue) {
    return value != null ? value : defaultValue;
}
export function getNumber(num, defaultValue) {
    return num != null && Number.isFinite(num) ? num : defaultValue;
}
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/registry/filter/util.js
// module id = null
// module chunks = 